import { render } from "./settle.vue?vue&type=template&id=480f1e06&scoped=true"
import script from "./settle.vue?vue&type=script&lang=js"
export * from "./settle.vue?vue&type=script&lang=js"

import "./settle.vue?vue&type=style&index=0&id=480f1e06&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480f1e06"]])

export default __exports__